// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stepView__Rphao {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.stepViewTitle__Yc23y {
  font-family: "Roboto", sans-serif;
  font-size: 18px;
  font-weight: 500;
  line-height: 20px;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 0.25px;
  color: var(--header-title-main);
  margin-bottom: 15px;
}

.stepViewDisclaimer__Ph_sm {
  font-size: 12px;
  line-height: 16px;
  color: var(--tables-secondary-row-sub-title-text);
  margin: 0 -25px;
  padding: 0 25px;
}

.supportLink__oTtfM {
  font-family: "Roboto", sans-serif;
  font-size: 12px;
  line-height: 12px;
  color: var(--buttons-surface);
  text-decoration: none;
  background-color: transparent;
  border: none;
  cursor: pointer;
}

.stepViewClarification__mRIwB {
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  color: var(--tables-secondary-row-sub-title-text);
  margin-top: 8px;
  margin-bottom: 0;
}

.stepViewInfo__sbYFy {
  width: 270px;
  height: 100px;
  margin-top: 3px;
  display: grid;
  grid-template-columns: 80px 80px;
  grid-column-gap: 50px;
  justify-content: center;
  align-items: center;
  padding: 8px 25px;
}

.itemIcon__J0qbU {
  max-height: 50px;
}

.itemText__x8KE9 {
  font-size: 10px;
  line-height: 12px;
  text-align: center;
  text-transform: uppercase;
  color: var(--tables-secondary-row-sub-title-text);
  margin-top: 10px;
}

.stepFormInfo__OADfs {
  height: 100%;
}

.twoParts__M9d5r {
  display: grid;
  grid-template-columns: 1fr 210px;
  column-gap: 25px;
}

.otherBlock__Iq7AA {
  height: 100%;
  max-height: 210px;
  display: grid;
  margin-top: 10px;
}

.photoBlock__T_Zfz {
  height: 100%;
}

.imageWrapper__B41wq {
  position: relative;
}

.photoBlockImage__NipEf {
  width: 100%;
  height: 210px;
  flex-shrink: 0;
  object-fit: cover;
}

.removeIcon__ZjD8m {
  position: absolute;
  top: 5px;
  right: 5px;
  cursor: pointer;
}

.fieldLabel__oiiRO {
  font-size: 10px;
  line-height: 12px;
  text-transform: uppercase;
  color: #75899d;
  display: block;
  margin-bottom: 8px;
  padding-right: 17px;
}

.required__tmDOn::after {
  content: "*";
  font-size: 10px;
  line-height: 12px;
  color: var(--inputs-error-text-helper);
  margin-left: 4px;
}

.attachmentsField__UCgXx {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px dashed var(--buttons-surface);
  cursor: pointer;
}

.attachmentsFieldLink__rm01Z {
  font-size: 14px;
  line-height: 12px;
  color: var(--buttons-surface);
  text-decoration: underline;
  padding-top: 5px;
  cursor: pointer;
}

.helperText__FuEUH {
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  color: var(--inputs-error-text-helper);
  margin-top: 4px;
  min-height: 11px;
}
@media (max-width: 850px) {
  .helperText__FuEUH {
    font-size: 8px;
    line-height: 8px;
    margin-top: 2px;
    min-height: 8px;
  }
}

.stepViewInfoItem__tuUY6 {
  display: flex;
  flex-direction: column;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./../src/components/modals/SensorReplaceModal/components/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAzEF;;AA4EA;EACE,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,+BAAA;EACA,mBAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,iBAAA;EACA,iDAAA;EACA,eAAA;EACA,eAAA;AAzEF;;AA4EA;EACE,iCAAA;EACA,eAAA;EACA,iBAAA;EACA,6BAAA;EACA,qBAAA;EACA,6BAAA;EACA,YAAA;EACA,eAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,iDAAA;EACA,eAAA;EACA,gBAAA;AAzEF;;AA4EA;EACE,YAAA;EACA,aAAA;EACA,eAAA;EACA,aAAA;EACA,gCAAA;EACA,qBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;AAzEF;;AA4EA;EACE,gBAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,iDAAA;EACA,gBAAA;AAzEF;;AA4EA;EACE,YAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,gCAAA;EACA,gBAAA;AAzEF;;AA4EA;EACE,YAAA;EACA,iBAAA;EACA,aAAA;EACA,gBAAA;AAzEF;;AA4EA;EACE,YAAA;AAzEF;;AA4EA;EACE,kBAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,aAAA;EACA,cAAA;EACA,iBAAA;AAzEF;;AA4EA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AAzEF;;AA4EA;EACE,YAAA;EACA,eAAA;EACA,iBAAA;EACA,sCAAA;EACA,gBAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,yCAAA;EACA,eAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,iBAAA;EACA,6BAAA;EACA,0BAAA;EACA,gBAAA;EACA,eAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sCAAA;EACA,eAAA;EACA,gBAAA;AAzEF;AA2EE;EARF;IASI,cAAA;IACA,gBAAA;IACA,eAAA;IACA,eAAA;EAxEF;AACF;;AA0EA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAvEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.stepView {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.stepViewTitle {\n  font-family: 'Roboto', sans-serif;\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 20px;\n  text-align: center;\n  text-transform: uppercase;\n  letter-spacing: 0.25px;\n  color: var(--header-title-main);\n  margin-bottom: 15px;\n}\n\n.stepViewDisclaimer {\n  font-size: 12px;\n  line-height: 16px;\n  color: var(--tables-secondary-row-sub-title-text);\n  margin: 0 -25px;\n  padding: 0 25px;\n}\n\n.supportLink {\n  font-family: 'Roboto', sans-serif;\n  font-size: 12px;\n  line-height: 12px;\n  color: var(--buttons-surface);\n  text-decoration: none;\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n}\n\n.stepViewClarification {\n  font-size: 12px;\n  line-height: 18px;\n  text-align: center;\n  color: var(--tables-secondary-row-sub-title-text);\n  margin-top: 8px;\n  margin-bottom: 0;\n}\n\n.stepViewInfo {\n  width: 270px;\n  height: 100px;\n  margin-top: 3px;\n  display: grid;\n  grid-template-columns: 80px 80px;\n  grid-column-gap: 50px;\n  justify-content: center;\n  align-items: center;\n  padding: 8px 25px;\n}\n\n.itemIcon {\n  max-height: 50px;\n}\n\n.itemText {\n  font-size: 10px;\n  line-height: 12px;\n  text-align: center;\n  text-transform: uppercase;\n  color: var(--tables-secondary-row-sub-title-text);\n  margin-top: 10px;\n}\n\n.stepFormInfo {\n  height: 100%;\n}\n\n.twoParts {\n  display: grid;\n  grid-template-columns: 1fr 210px;\n  column-gap: 25px;\n}\n\n.otherBlock {\n  height: 100%;\n  max-height: 210px;\n  display: grid;\n  margin-top: 10px;\n}\n\n.photoBlock {\n  height: 100%;\n}\n\n.imageWrapper {\n  position: relative;\n}\n\n.photoBlockImage {\n  width: 100%;\n  height: 210px;\n  flex-shrink: 0;\n  object-fit: cover;\n}\n\n.removeIcon {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  cursor: pointer;\n}\n\n.fieldLabel {\n  font-size: 10px;\n  line-height: 12px;\n  text-transform: uppercase;\n  color: #75899d;\n  display: block;\n  margin-bottom: 8px;\n  padding-right: 17px;\n}\n\n.required::after {\n  content: '*';\n  font-size: 10px;\n  line-height: 12px;\n  color: var(--inputs-error-text-helper);\n  margin-left: 4px;\n}\n\n.attachmentsField {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  border: 1px dashed var(--buttons-surface);\n  cursor: pointer;\n}\n\n.attachmentsFieldLink {\n  font-size: 14px;\n  line-height: 12px;\n  color: var(--buttons-surface);\n  text-decoration: underline;\n  padding-top: 5px;\n  cursor: pointer;\n}\n\n.helperText {\n  font-size: 10px;\n  font-weight: 400;\n  line-height: 12px;\n  color: var(--inputs-error-text-helper);\n  margin-top: 4px;\n  min-height: 11px;\n\n  @media (max-width: 850px) {\n    font-size: 8px;\n    line-height: 8px;\n    margin-top: 2px;\n    min-height: 8px;\n  }\n}\n.stepViewInfoItem {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stepView": `stepView__Rphao`,
	"stepViewTitle": `stepViewTitle__Yc23y`,
	"stepViewDisclaimer": `stepViewDisclaimer__Ph_sm`,
	"supportLink": `supportLink__oTtfM`,
	"stepViewClarification": `stepViewClarification__mRIwB`,
	"stepViewInfo": `stepViewInfo__sbYFy`,
	"itemIcon": `itemIcon__J0qbU`,
	"itemText": `itemText__x8KE9`,
	"stepFormInfo": `stepFormInfo__OADfs`,
	"twoParts": `twoParts__M9d5r`,
	"otherBlock": `otherBlock__Iq7AA`,
	"photoBlock": `photoBlock__T_Zfz`,
	"imageWrapper": `imageWrapper__B41wq`,
	"photoBlockImage": `photoBlockImage__NipEf`,
	"removeIcon": `removeIcon__ZjD8m`,
	"fieldLabel": `fieldLabel__oiiRO`,
	"required": `required__tmDOn`,
	"attachmentsField": `attachmentsField__UCgXx`,
	"attachmentsFieldLink": `attachmentsFieldLink__rm01Z`,
	"helperText": `helperText__FuEUH`,
	"stepViewInfoItem": `stepViewInfoItem__tuUY6`
};
module.exports = ___CSS_LOADER_EXPORT___;
